<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-checkout"
      size="lg"
      scrollable
      centered
      @hide="hideModal"
      @close="hideModal"
    >
      <template #modal-title>
        <i class="icon-note"></i> REGISTRAR CHECK-OUT
      </template>

      <div class="form-group row">
        <div class="col-md-12 mb-2">
          <div class="row">
            <div class="col-md-6 mt-2">
              <NxSelectTipoVisita
                @update:value="handleSelectUpdate('tipoVisitasId', $event)"
              />
            </div>
            <div class="col-md-6 mt-2">
              <NxSelectStatusVisita
                @update:value="handleSelectUpdate('statusVisitas', $event)"
              />
            </div>
          </div>
        </div>

        <hr class="w-100" />

        <div class="col-md-12">
          <div
            v-for="(item, index) in formData"
            :key="index"
            class="add-products-container__layout pl-3 py-2 mb-2"
          >
            <div class="form-group row">
              <div
                class="col-12 row"
                style="align-items: center"
              >
                <div class="col-12 col-lg-8">
                  <NxSelectProduto
                    :value="item.produto"
                    :multiple="false"
                    @update:value="
                      handleArrayIndexUpdate(index, 'produto', $event, 'select')
                    "
                  />
                </div>
                <div class="col-8 col-lg-3">
                  <NxInputMoney
                    :value="item.valorProduto"
                    labelText="Valor do produto:"
                    @update:value="
                      handleArrayIndexUpdate(
                        index,
                        'valorProduto',
                        $event,
                        'input',
                        false
                      )
                    "
                  />
                </div>
                <div
                  class="col-1 pt-4 pointer"
                  style="margin: 0 auto"
                  @click.prevent="removeProductItemInArray(index)"
                >
                  <i
                    class="fas fa-times-circle fa-lg"
                    style="color: #ff0000"
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <div>
            <button
              type="button"
              class="btn rounded-4 btn-third"
              @click="addProductItemInArray"
            >
              <i class="fas fa-plus"></i> Produto
            </button>
          </div>
        </div>

        <hr class="w-100" />

        <div class="col-md-12">
          <NxInputObservacao
            placeholder="Digite como foi a visita..."
            @update:value="handleInputUpdate('comentario', $event, false)"
          />
        </div>

        <hr class="w-100" />

        <div class="col-md-12">
          <div
            class="d-flex"
            style="
              justify-content: start;
              align-items: start;
              gap: 1rem;
              cursor: pointer;
            "
            @click="toggleCreateCard"
          >
            <ToogleSwitch :value="hasCard" />
            <h6 style="line-height: 100%">Criar Oportunidade</h6>
          </div>

          <section
            v-if="hasCard"
            class="row"
          >
            <div
              class="input-group"
              style="background: none"
            >
              <div class="col-md-6 mt-2">
                <SelectEvento
                  @onSelect="saveEvento"
                  :selectedOption="data.eventoId"
                />
              </div>
              <div class="col-md-6 mt-2">
                <SelectBoard
                  :onlyActive="true"
                  :selectedOption="data.boardId"
                  @onSelect="loadColumns"
                />
              </div>
              <div class="col-md-6 mt-2">
                <SelectBoardColumn
                  v-if="data.boardId"
                  :boardId="data.boardId"
                  :key="data.boardId"
                  :selectedOption="data.boardColumnId"
                  @onSelect="saveBoardAndColumn"
                />
              </div>
              <div class="col-md-6 pt-2">
                <SelectOrigem
                  v-if="data.boardColumnId"
                  :selectedOption="data.origemId"
                  @onSelect="saveOrigin"
                />
              </div>
            </div>
          </section>
        </div>
      </div>

      <template #modal-footer>
        <DefaultButton
          btnVariant="btn-third justify-content-center"
          :onClick="onSave"
          icon="fas fa-check-circle"
          text="Salvar"
        />
      </template>
    </b-modal>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import ParametroAberturaCardsVisitaRepository from '@/shared/http/repositories/configurations/parametroAberturaCardsVisita.js'
import DeslocamentoRepository from '@/shared/http/repositories/deslocamento/deslocamento.js'

import {
  NxInputMoney,
  NxInputObservacao
} from '@/components/nexum/components/custom-inputs/index.js'
import {
  NxSelectProduto,
  NxSelectStatusVisita,
  NxSelectTipoVisita
} from '@/components/nexum/components/custom-selects/index.js'

import DefaultButton from '@/components/UI/button/defaultButton.vue'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'
import SelectBoard from '@/components/forms/selects/SelectBoard.vue'
import SelectBoardColumn from '@/components/forms/selects/SelectBoardColumn.vue'
import SelectEvento from '@/components/forms/selects/SelectEvento.vue'
import SelectOrigem from '@/components/forms/selects/SelectOrigem.vue'

export default {
  name: 'CheckOutModal',
  mixins: [ActionsForm],
  data () {
    return {
      data: {
        id: null,
        deslocamentoId: null,
        tipoVisitasId: null,
        statusVisitas: null,
        hasProduct: false,
        listaProdutos: null,
        comentario: null,
        hasCard: false,
        eventoId: null,
        boardId: null,
        boardColumnId: null,
        origemId: null
      },
      hasCard: false,
      formData: []
    }
  },
  components: {
    DefaultButton,
    ToogleSwitch,

    NxSelectTipoVisita,
    NxSelectStatusVisita,
    NxSelectProduto,
    NxInputMoney,
    NxInputObservacao,

    SelectBoard,
    SelectBoardColumn,
    SelectOrigem,
    SelectEvento
  },
  methods: {
    async showModal () {
      loading.push()
      await this.getDeslocamento()
      this.$refs['modal-checkout'].show()
    },
    hideModal () {
      this.$refs['modal-checkout'].hide()
    },
    async getDeslocamento () {
      try {
        const response = await DeslocamentoRepository.GetActive()

        if (response.data === '') return

        const visita = response.data.visitas.find(
          (v) => v.dataCheckOut === null
        )

        if (visita === null) return

        this.data.id = visita.id
        this.data.deslocamentoId = response.data.id
      } catch (e) {
        console.error(e)
      } finally {
        loading.close()
      }
    },
    async getParametrosOpenCard () {
      try {
        loading.push()
        const resp = await ParametroAberturaCardsVisitaRepository.Get()

        if (!resp || !resp.data) return

        this.data.eventoId = resp.data.eventoId
        this.data.boardId = resp.data.boardId
        this.data.boardColumnId = resp.data.boardColumnId
        this.data.origemId = resp.data.origemLeadId
      } catch (error) {
        this.onExceptionWithErrorMessage(error)
      } finally {
        loading.close()
      }
    },
    async onUpdate () {
      try {
        if (this.hasCard && !this.checkFieldsCreateCard()) return
        if (this.checkRequiredFields()) return

        loading.push()

        this.data.hasCard = this.hasCard
        this.setProductListOnData()

        await DeslocamentoRepository.CheckOut(this.data)

        toast.success(this.$lang.Common.Alerts.Success)
        this.hideModal()
        location.reload()
      } catch (error) {
        toast.error(this.$lang.Common.Alerts.Error)
      } finally {
        loading.pop()
      }
    },
    async toggleCreateCard () {
      this.hasCard = !this.hasCard

      if (this.hasCard) {
        await this.getParametrosOpenCard()
      }
    },
    checkRequiredFields () {
      const valuesToCheck = [null, undefined]
      if (
        valuesToCheck.includes(this.data.statusVisitas) ||
        valuesToCheck.includes(this.data.tipoVisitasId)
      ) {
        toast.warning(this.$lang.Common.Alerts.RequiredField)
        return true
      }
      return false
    },
    checkFieldsCreateCard () {
      if (this.data.boardId && this.data.boardColumnId && this.data.origemId) {
        return true
      }

      toast.warning(
        'Todos os campos devem estar preenchidos',
        'Criar oportunidade'
      )

      return false
    },
    saveEvento (eventoId) {
      this.data.eventoId = eventoId
    },
    saveBoardAndColumn (boardAndColumn) {
      this.data.boardId = boardAndColumn[0]
      this.data.boardColumnId = boardAndColumn[1]
    },
    loadColumns (boardId) {
      this.data.boardId = boardId
    },
    saveOrigin (origin) {
      this.data.origemId = origin
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If input comes as a string or a number
      if (
        typeof selectedValue === 'string' ||
        typeof selectedValue === 'number'
      ) {
        this.data[fieldName] = selectedValue
        return
      }

      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }

      // If to clear single select and update both types
      this.data[fieldName] = selectedValue
        ? Array.isArray(selectedValue)
          ? selectedValue.map((v) => v.value)
          : selectedValue.value
        : this.clearField(fieldName)
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      this.data[fieldName] = inputedValue
        ? clean
          ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
          : inputedValue
        : this.clearField(fieldName)
    },
    handleArrayIndexUpdate (
      index,
      fieldName,
      selectedValue,
      inputType,
      clean = true
    ) {
      // If field is on array index
      if (index < 0) return

      if (inputType === 'select') {
        // If input comes as a string or a number
        if (
          typeof selectedValue === 'string' ||
          typeof selectedValue === 'number'
        ) {
          this.formData[index][fieldName] = selectedValue
          return
        }
        // If to clear multiple select
        if (Array.isArray(selectedValue) && !selectedValue.length) {
          this.formData[index][fieldName] = null
          return
        }
        // If to clear single select and update both types
        this.formData[index][fieldName] = selectedValue || null
      } else {
        this.formData[index][fieldName] = selectedValue
          ? clean
            ? selectedValue.replace(/[^a-zA-Z0-9 ]/g, '')
            : selectedValue
          : null
      }
    },
    clearField (field) {
      this.data[field] = null
    },
    addProductItemInArray () {
      this.formData.push({
        produto: null,
        valorProduto: 0
      })
    },
    removeProductItemInArray (index) {
      this.formData.splice(index, 1)
    },
    setProductListOnData () {
      if (this.formData.length === 0) {
        this.data.hasProduct = false
        this.data.listaProdutos = null
        return
      }

      this.data.hasProduct = true

      this.data.listaProdutos = this.formData.map((item) => ({
        produtoId: item.produto.value,
        valorProduto: item.valorProduto
      }))
    }
  }
}
</script>

<style lang="scss">
#produtcs-groups {
  .formulate-input {
    margin-bottom: 0px;

    .formulate-input-element {
      max-width: none;

      textarea {
        height: 7rem;
        border-radius: 0.3rem 0.3rem 0px 0px;
        resize: none;
      }
    }
  }
}

.add-products-container__layout {
  background-color: rgb(229, 229, 229);
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/deslocamento/register/modal/checkout.vue